import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { PaymentBulkSummaryModel } from '../../../../core/models/data/payment-bulk-summary.model';
import { CurrencyModel } from '../../../../core/models/data/currency.model';
import { CurrencyDisplayPipe } from '../../../../core/pipes/currency/currency.pipe';

@Component({
  selector: 'ms-payment-history-summary-cards',
  imports: [CommonModule, FaDuotoneIconComponent, CurrencyDisplayPipe],
  templateUrl: './payment-history-summary-cards.component.html',
  styleUrl: './payment-history-summary-cards.component.scss'
})
export class PaymentHistorySummaryCardsComponent {
  public summary = input<PaymentBulkSummaryModel | undefined>(undefined);
  public currency = input<CurrencyModel | undefined>(undefined);
  public isLoading = input<boolean>(false);
}
